export default __webpack_public_path__ + "static/media/arrows-double-right.e338abcc.svg";